import styled from "styled-components";

export const GridHeadline = styled.div`
	font-size: 1.2rem;
	padding-bottom: 8px;
	font-weight: 500;
`;

export const GridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(var(--number-of-items), 1fr);
	gap: 1.6rem;
`;
